import { Route, Routes } from 'react-router-dom';
import Dashboard from './components/Dashboard/Home';
import MachineRequestsList from './machineListView';
import MachineRequestDetail from './machineRequestDetail';
import QuotationDetail from './quotationDetail';
import PurchaseOrderList from './purchaseOrderView';
import PurchaseOrderDetail from './purchaseOrderDetails';
import InstallationList from './installationView';
import InstallationDetails from './installationDetails';
import Report from './report';
import MachineExpenseReport from './machineExpenseReport';
function MachineRoutes() {
  return (
    <Routes>
      <Route path="dashboard" element={<Dashboard />} />
      <Route path="machine-requests" element={<MachineRequestsList />} />
      <Route path="machine-requests/:id" element={<MachineRequestDetail />} />
      <Route path="machine-requests/:requestId/quotations/:quotationId" element={<QuotationDetail />} />
      <Route path="purchase-orders" element={<PurchaseOrderList />} />
      <Route path="purchase-orders/:purchaseId" element={<PurchaseOrderDetail />} />
      <Route path="installation" element={<InstallationList />} />
      <Route path="installation/:id" element={<InstallationDetails />} />
      <Route path="report" element={<Report />} />
      <Route path="machine-expense-report" element={<MachineExpenseReport />} />
    </Routes>
  );
}

export default MachineRoutes;
